<ng-container *ngIf="!isEmpty; else empty">
  <cdk-tree  [dataSource]="folders"
             [treeControl]="config.treeControl">
    <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="example-tree-node">
      <ng-container *ngIf="node.qverID">
        <div class="list-row list-row-auto-1-auto app-cursor-pointer"
             (click)="openEntity(node)">
          <div></div>
          <div class="">
            <div class="list-primary-text">{{node.qverName}}</div>
            <div class="list-secondary-text">{{node.qverDescription}}</div>
          </div>
          <div class="list-metadata">
            <div class="typo-right">{{node.qverLCD | excDate: 'dd.MM.yyyy HH:mm'}}</div>
            <div class="typo-right">{{node.qverLCU}}</div>
          </div>
          <div></div>
          <div class="typo-left typo-small">
            {{enumSvc.getEnumerationText('QuestionnaireVersionStatus', node.qverQuestionnaireVersionStatus_enmIdent)}}
          </div>
          <div class="typo-right">
            <i class="search-action fa-duotone fa-file-excel"
               [tooltip]="'Excel Report öffnen'"
               *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
               (click)="config.exportQuestionnaireReportExcel($event, node)">
            </i>
            <i class="search-action fa-duotone fa-file-pdf"
               [tooltip]="'PDF Report öffnen'"
               *ngIf="excSecurity.isFeatured('QUESTVERREPORT')"
               (click)="config.exportQuestionnaireReportPDF($event, node)">
            </i>
            <i [tooltip]="'Beschreibung editieren'"
               (click)="config.openQuestionnaireVersion($event, node)"
               class="search-action fad fa-pen">
            </i>
            <i [tooltip]="'Löschen'"
               (click)="config.deleteQuestionnaireVersion($event, node)"
               class="search-action fad fa-trash"></i>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="node.cvID">
        <div class="list-row list-row-auto-1-auto app-cursor-pointer"
             (click)="openEntity(node)">
          <div></div>
          <div class="">
            <div class="list-primary-text">{{node.cvName}}</div>
            <div class="list-secondary-text">{{node.cvDescription}}</div>
          </div>
          <div class="list-metadata">
            <div class="typo-right">{{node.cvCRD | excDate: 'dd.MM.yyyy HH:mm'}}</div>
            <div class="typo-right">{{node.cvCRU}}</div>
          </div>
          <div></div>
          <div class="typo-left typo-small">
            {{enumSvc.getEnumerationText('CalculationVersionStatus', node.cvCalculationVersionStatus_enmIdent)}}
          </div>
          <div class="typo-right">
            <i [tooltip]="'Beschreibung editieren'"
               (click)="config.openModalCalculationVersion($event, node)"
               class="search-action fad fa-pen">
            </i>
            <i [tooltip]="'Löschen'"
               (click)="config.deleteCalculationVersion($event, node)"
               class="search-action fad fa-trash"></i>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="node.pdID">
        <div class="list-row list-row-auto-1 app-cursor-pointer"
             (click)="openEntity(node)">
          <div></div>
          <div class="grid-1-auto">
            <div class="layout-1-auto">
              <span>{{node.pdName}}</span>
              <span [tooltip]="node.pdDescription" class="list-metadata" style="margin-left: 0;">{{node.pdDescription}}</span>
            </div>
            <div class="layout-1-auto typo-small">
              <span class="list-metadata" style="text-align: right">{{node.pdLCD | excDate: getGlobal('DateTimeFormatShort')}}</span>
              <span class="list-metadata" style="text-align: right">{{node.pdLCU}}</span>
            </div>
            <div class="typo-left typo-small">
              {{enumSvc.getEnumerationText('PhotoDocumentationStatus', node.pdPhotoDocumentationStatus_enmIdent)}}
            </div>
            <div class="typo-right">
              <i [tooltip]="'Beschreibung editieren'"
                 class="search-action fad fa-pen"
                 (click)="config.openPhotoDocEditTextModal($event, false, node)">
              </i>
              <i [tooltip]="'Löschen'"
                 (click)="config.deletePhotoDoc($event, node)"
                 class="search-action fad fa-trash"></i>
            </div>
          </div>
        </div>
      </ng-container>
    </cdk-nested-tree-node>
    <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: config.hasChild"
                          class="example-tree-node">
      <div class="list-row app-cursor-pointer"
           *ngIf="node.dokFolderCount > 0"
           cdkTreeNodeToggle>
        <div class="grid-auto-1" style="padding:0.5rem">
          <div class="list-avatar nobackground">
            <i class="far fa-fw"
               [class.fa-folder-open]="config.treeControl.isExpanded(node)"
               [class.fa-folder]="!config.treeControl.isExpanded(node)">
            </i>
          </div>
          <div class="layout-1-auto">
            <div class="list-metadata" style="margin-left:0">
              {{node.dokFolderCount}} {{getRessource(node.source + 'Count')}}
            </div>
            <div>
              {{getRessource(node.source + 'Count')}}
            </div>
          </div>
        </div>
      </div>
      <div [hidden]="!config.treeControl.isExpanded(node)">
        <ng-container cdkTreeNodeOutlet></ng-container>
      </div>
    </cdk-nested-tree-node>
  </cdk-tree>
</ng-container>
<ng-template #empty>
  <div class="splash empty">
    <p style="width: inherit">Es wurden keine Berichte gefunden!</p>
  </div>
</ng-template>
